import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const DeepLink = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  window.location = searchParams.get('link');
  return null;
}

export default DeepLink;